import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../../stores/useAuthStore'; // 🟢 1. Importamos el store de Zustand

const ProtectedRoute = () => {
  // � FIX CRÍTICO #185: Selectores individuales (NO objeto)
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const isLoading = useAuthStore((state) => state.isLoading);

  // Mientras se verifica el estado de autenticación, no renderizamos nada.
  // Esto evita una redirección prematura a /login cuando la página se recarga.
  if (isLoading) {
    return null; // O un spinner de carga global
  }

  // Si el usuario no ha iniciado sesión, redirige a la página de autenticación
  if (!isLoggedIn) {
    // 🟢 3. Corregimos la ruta a /login para mantener la consistencia.
    return <Navigate to="/login" replace />;
  }

  // Si el usuario sí ha iniciado sesión, renderiza la página que intentaba visitar
  return <Outlet />;
};

export default ProtectedRoute;
